import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';
import { Popover } from 'material-ui';

const StevedoringPopover = ({ serviceProvider }) => {
    const [popoverState, setPopoverState] = React.useState({
        openPopover: false,
        anchorElPopover: null,
    });

    const handleClickPopover = React.useCallback((event) => {
        // This prevents ghost click
        event.preventDefault();
        setPopoverState({
            openPopover: true,
            anchorElPopover: event.currentTarget,
        });
    }, []);

    const handleRequestClosePopover = React.useCallback(() => {
        setPopoverState(prev => ({
            ...prev,
            openPopover: false,
        }));
    }, []);

    const { openPopover, anchorElPopover } = popoverState;

    return (
        <React.Fragment>
            {serviceProvider.activities.map((activity, index) => (
                <div key={`activity_${index}`}>
                    <span>{activity}</span>
                    <br />
                </div>
            ))}

            <div className="icon info-icon">
                <Popover
                    open={openPopover}
                    anchorEl={anchorElPopover}
                    anchorOrigin={{ horizontal: 'middle', vertical: 'center' }}
                    targetOrigin={{ horizontal: 'middle', vertical: 'center' }}
                    onRequestClose={handleRequestClosePopover}
                >
                    <div className="paper-block stevedoring-popover">
                        <div className='title'>{serviceProvider.activities.join(',')}</div>
                        <div className="limitations">
                            {(serviceProvider.limitations || []).map((limitation, limitationIndex) => (
                                <div key={`limitation_stevedoring_${limitationIndex}`}>
                                    <span className='limitation__counter'>
                                        {`Limitation: ${limitationIndex + 1}`}
                                    </span>
                                    <div className="limitation">
                                        Berth{' '}
                                        <span style={{ wordBreak: 'break-all', position: 'inherit' }}>
                                            {limitation.berth}
                                        </span>
                                    </div>
                                    <div className="limitation">
                                        Max draft <span>{limitation.maxDraught} m</span>
                                    </div>
                                    <div className="limitation">
                                        Max beam <span>{limitation.maxBeam} m</span>
                                    </div>
                                    <div className="limitation">
                                        Max LOA <span>{limitation.maxLOA} m</span>
                                    </div>
                                    <div className="limitation">
                                        Max DWT <span>{limitation.maxDWT} m</span>
                                    </div>
                                    <div className="limitation">
                                        Channel depth <span>{limitation.channelDepth} m</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Popover>
                <IconButton
                    iconStyle={{ color: '#CBCBCB' }}
                    onClick={handleClickPopover}
                >
                    <InfoIcon style={{ color: '#CBCBCB' }} />
                </IconButton>
            </div>
        </React.Fragment>
    );
};

StevedoringPopover.propTypes = {
    serviceProvider: PropTypes.shape({
        activities: PropTypes.arrayOf(PropTypes.string).isRequired,
        limitations: PropTypes.arrayOf(PropTypes.shape({
            berth: PropTypes.string,
            maxDraught: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            maxBeam: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            maxLOA: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            maxDWT: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            channelDepth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })).isRequired,
    }).isRequired,
};

export default StevedoringPopover;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/StevedoringPopover.jsx